import { Relationship } from '@leverege/molten/data-source';
import { Types, Routes, Names } from "../constants/index.js";
export default (molten => {
  const rel = new Relationship({
    systemId: molten.getConfig('api/systemId'),
    apiName: Types.apiName,
    get name() {
      return Names.firmwareReleasePlural;
    },
    objectType: Types.firmwareRelease,
    path: 'leverege.fotaApi.firmwareRelease',
    refPath: '/firmwareRelease',
    urlPath: Routes.rootFirmwareRelease,
    isGroup: true
  }, {
    match: {}
  });
  rel.blueprint = {
    type: rel.objectType,
    name: Names[rel.objectType],
    namePlural: Names[`${rel.objectType}Plural`],
    getIcon: () => null
  };
  return rel;
});